import React, { useState } from "react";
import { Link } from "react-router-dom";
import Footer from "./footer";

const Faqs = () => {
  const faqs = [
    {
      q: "What is BI Manager?",
      a: "BI Manager is a platform to manage RFQs and vendor quotations easily.",
    },
    {
      q: "Who can use BI Manager?",
      a: "Buyers, vendors, and businesses of all sizes can use BI Manager.",
    },
    {
      q: "Is BI Manager free to use?",
      a: "Basic features are free. Advanced features may require a subscription.",
    },
    {
      q: "Who developed BI Manager?",
      a: "BI Manager is developed and powered by The Nexteck Company.",
    },
  ];

  const [activeIndex, setActiveIndex] = useState(0); // 👈 first open by default
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

  const toggleNav = () => setIsMobileNavOpen(!isMobileNavOpen);
  const closeNav = () => setIsMobileNavOpen(false);

  return (
    <>
      {/* HEADER */}
      <div style={{ backgroundColor: "#51477E" }}>
        <header className="header container">
          <div className="header-top">
            <div className="logoManager">
              <Link to="/" style={{ textDecoration: "none" }}>
                <h3 style={{ color: "#fff" }}>
                  BI <span>Manager</span>
                </h3>
              </Link>
            </div>

            <button className="nav-toggle d-md-none" onClick={toggleNav}>
              ☰
            </button>
          </div>

          <nav className={`nav ${isMobileNavOpen ? "open" : ""}`}>
            <button className="nav-close d-md-none" onClick={closeNav}>✕</button>
            <ul>
              <li><Link to="/" onClick={closeNav}>Home</Link></li>
              <li><Link to="/about" onClick={closeNav}>About</Link></li>
              <li><Link to="/" onClick={closeNav}>CreateRFQ</Link></li>
              <li><Link to="/" onClick={closeNav}>ForVendors</Link></li>
              <li><Link to="/faqs" onClick={closeNav}>FAQ's</Link></li>
              <li><Link to="/contact" onClick={closeNav}>Contact</Link></li>
              <li>
                <Link to="/login">
                  <button className="login-btn">Login</button>
                </Link>
              </li>
            </ul>
          </nav>
        </header>
      </div>

      {/* FAQ SECTION */}
      <div className="container py-5">
        <h2 className="mb-4" style={{ color: "#FF650F" }}>
          Frequently Asked Questions
        </h2>

        {faqs.map((faq, index) => (
          <div
            key={index}
            className="mb-3 p-3 border rounded"
            style={{ cursor: "pointer" }}
            onClick={() => setActiveIndex(index)}
          >
            <h6 className="mb-2">
              {activeIndex === index ? "➖" : "➕"} {faq.q}
            </h6>

            {activeIndex === index && (
              <p className="mb-0 text-muted">{faq.a}</p>
            )}
          </div>
        ))}
      </div>

      <Footer />
    </>
  );
};

export default Faqs;
